import ScheduleListRow from './ScheduleListRow';
export default class Project extends ScheduleListRow {
	constructor(params) {
		super(params);
		
		if (params.schedules !== undefined)
			this.schedules = params.schedules;
		else
			this.schedules = new Array();
		
		this.item_type = ScheduleListRow.ITEM_TYPE.PROJECT;
	}
}